<template>
    <el-dialog
            :visible.sync="dialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :before-close="handleClose"
            width="30%">
        <el-card class="box-card" style="margin:10px 0;">
            <div class="text item">
                <span class="box-card_title" v-if="document.taskType === 'PROJECT'">{{$t('modal_documentManagment_status_project')}}</span>
                <span class="box-card_title" v-if="document.taskType === 'BUSINESSUNIT'">{{$t('modal_documentManagment_status_businessUnit')}}</span>
                <span class="box-card_title" v-if="document.taskType === 'ENGAGEMENT'">{{$t('modal_documentManagment_status_engagement')}}</span>
                {{document.projectName}}
            </div>
            <el-divider></el-divider>
            <div class="text item">
                <span class="box-card_title">{{$t('modal_documentManagment_status_task')}}</span> {{document.taskName}}
            </div>
            <el-divider></el-divider>
            <div class="text item">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentType')}}</span>
                <span style="text-transform: uppercase;" v-if="document.type === 'healthsafety'"> Health & safety</span>
                <span style="text-transform: uppercase;" v-else> {{document.type}}</span>
            </div>
            <el-divider></el-divider>
            <!--SOP-->
            <div class="text item" v-if="document.type === 'sop'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentNo')}}</span>{{document["sop.number"]}}
            </div>
            <!--POLICY-->
            <div class="text item" v-if="document.type === 'policy'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentNo')}}</span> {{document['policy.number']}}
            </div>
            <!--HEALTH SAFETY-->
            <div class="text item" v-if="document.type === 'healthsafety'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentNo')}}</span> {{document['healthsafety.number']}}
            </div>
            <!--RISK ASSESMENT COMMERCIAL-->
            <div class="text item" v-if="document.type === 'riskassesment' || document.type === 'commercial'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentNo')}}</span> {{document['riskassesment.number']}}
            </div>
            <!--ENVIRIMENTAL GENERAL-->
            <div class="text item" v-if="document.type === 'envirenmental' || document.type === 'general'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentNo')}}</span> {{document['envirenmental.number']}}
            </div>
            <el-divider></el-divider>


            <!--SOP-->
            <div class="text item" v-if="document.type === 'sop'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_revisionNo')}}</span>{{document['sop.revision']}}
            </div>
            <!--POLICY-->
            <div class="text item" v-if="document.type === 'policy'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_revisionNo')}}</span> {{document['policy.revision']}}
            </div>
            <!--HEALTH SAFETY-->
            <div class="text item" v-if="document.type === 'healthsafety'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_revisionNo')}}</span> {{document['healthsafety.revision']}}
            </div>
            <!--RISK ASSESMENT COMMERCIAL-->
            <div class="text item" v-if="document.type === 'riskassesment' || document.type === 'commercial'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_revisionNo')}}</span> {{document['riskassesment.revision']}}
            </div>
            <!--ENVIRIMENTAL GENERAL-->
            <div class="text item" v-if="document.type === 'envirenmental' || document.type === 'general'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_revisionNo')}}</span> {{document['envirenmental.revision']}}
            </div>

            <el-divider></el-divider>
            <div class="text item">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentTitle')}}</span>

                <span v-if="document.type === 'sop'"> {{document['sop.name']}}</span>
                <span v-if="document.type === 'policy'"> {{document['policy.name']}}</span>
                <span v-if="document.type === 'healthsafety'"> {{document['healthsafety.name']}}</span>
                <span v-if="document.type === 'riskassesment'"> {{document['riskassesment.name']}}</span>
                <span v-if="document.type === 'envirenmental'"> {{document['envirenmental.name']}}</span>
            </div>
        </el-card>

        <div v-if="title === 'sop'" class="item">
            <div v-if="documents.sop.editMessage" class="item__note">
                <el-alert
                        title="Information"
                        type="warning"
                        :description="documents.sop.editMessage"
                        show-icon>
                </el-alert>
            </div>
            <div class="item__title">
                <div v-if="documents.sop.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('project_tab_documents_accept')}}</el-tag>
                </div>
                <div v-if="documents.sop.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('project_tab_documents_reject')}}</el-tag>
                </div>
            </div>
            <div v-html="documents.sop.content" class="item__content"></div>

            <el-dropdown v-for="item in documents.sop.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.name}}</span>
                  </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url + `/${item.name}`)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}/${item.name}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                </el-dropdown-menu>
            </el-dropdown>

            <!-- confirmation -->
            <div v-if="documents.sop.level !== 0 && !documents.sop.isAccepted && !documents.sop.isRejected" style="margin-bottom: 20px; text-align: right;">
                <el-checkbox v-model="confirmation"></el-checkbox>&nbsp;
                <span style="font-size: 12px;">{{$t('project_tab_documents_sop_clicking')}}</span>
            </div>

            <div v-if="documents.sop.level !== 0 && !documents.sop.isAccepted && !documents.sop.isRejected" class="item__btn">
                <el-button :disabled="!confirmation" type="success" size="mini" @click="accept(1)">{{$t('project_tab_documents_accept')}}</el-button>
                <el-button type="danger" size="mini" @click="reject(1)">{{$t('project_tab_documents_reject')}}</el-button>
            </div>
        </div>

        <div v-if="title === 'policy'" class="item">
            <div v-if="documents.policy.editMessage" class="item__note">
                <el-alert
                        title="Information"
                        type="warning"
                        :description="documents.policy.editMessage"
                        show-icon>
                </el-alert>
            </div>
            <div class="item__title">
                <div v-if="documents.policy.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('project_tab_documents_accept')}}</el-tag>
                </div>
                <div v-if="documents.policy.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('project_tab_documents_reject')}}</el-tag>
                </div>
            </div>
            <div v-html="documents.policy.content" class="item__content"></div>

            <el-dropdown v-for="item in documents.policy.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.name}}</span>
                  </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url + `/${item.name}`)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}/${item.name}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                </el-dropdown-menu>
            </el-dropdown>

            <!-- confirmation -->
            <div v-if="documents.policy.level !== 0 && !documents.policy.isAccepted && !documents.policy.isRejected" style="margin-bottom: 20px; text-align: right;">
                <el-checkbox v-model="confirmation"></el-checkbox>&nbsp;
                <span style="font-size: 14px;">{{$t('project_tab_documents_policy_clicking')}}</span>
            </div>

            <div v-if="documents.policy.level !== 0 && !documents.policy.isAccepted && !documents.policy.isRejected" class="item__btn">
                <el-button :disabled="!confirmation" type="success" size="mini" @click="accept(2)">{{$t('project_tab_documents_accept')}}</el-button>
                <el-button type="danger" size="mini" @click="reject(2)">{{$t('project_tab_documents_reject')}}</el-button>
            </div>
        </div>

        <div v-if="title === 'healthsafety'" class="item">
            <div v-if="documents.healthsafety.editMessage" class="item__note">
                <el-alert
                        title="Information"
                        type="warning"
                        :description="documents.healthsafety.editMessage"
                        show-icon>
                </el-alert>
            </div>
            <div class="item__title">
                <div v-if="documents.healthsafety.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('project_tab_documents_accept')}}</el-tag>
                </div>
                <div v-if="documents.healthsafety.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('project_tab_documents_reject')}}</el-tag>
                </div>
            </div>
            <div v-html="documents.healthsafety.content" class="item__content"></div>

            <el-dropdown v-for="item in documents.healthsafety.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.name}}</span>
                  </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url + `/${item.name}`)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}/${item.name}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                </el-dropdown-menu>
            </el-dropdown>

            <!-- confirmation -->
            <div v-if="documents.healthsafety.level !== 0 && !documents.healthsafety.isAccepted && !documents.healthsafety.isRejected" style="margin-bottom: 20px; text-align: right;">
                <el-checkbox v-model="confirmation"></el-checkbox>&nbsp;
                <span style="font-size: 14px;">{{$t('project_tab_documents_healthSafety_clicking')}}</span>
            </div>

            <div v-if="documents.healthsafety.level !== 0 && !documents.healthsafety.isAccepted && !documents.healthsafety.isRejected" class="item__btn">
                <el-button :disabled="!confirmation" type="success" size="mini" @click="accept(3)">{{$t('project_tab_documents_accept')}}</el-button>
                <el-button type="danger" size="mini" @click="reject(3)">{{$t('project_tab_documents_reject')}}</el-button>
            </div>
        </div>

        <div v-if="title === 'riskassesment' || title === 'commercial'" class="item">
            <div v-if="documents.riskAssesment.editMessage" class="item__note">
                <el-alert
                        title="Information"
                        type="warning"
                        :description="documents.riskAssesment.editMessage"
                        show-icon>
                </el-alert>
            </div>
            <div class="item__title">
                <div v-if="documents.riskAssesment.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('project_tab_documents_accept')}}</el-tag>
                </div>
                <div v-if="documents.riskAssesment.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('project_tab_documents_reject')}}</el-tag>
                </div>
            </div>
            <div v-html="documents.riskAssesment.content" class="item__content"></div>

            <el-dropdown v-for="item in documents.riskAssesment.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.name}}</span>
                  </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url + `/${item.name}`)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}/${item.name}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                </el-dropdown-menu>
            </el-dropdown>

            <!-- confirmation -->
            <div v-if="documents.riskAssesment.level !== 0 && !documents.riskAssesment.isAccepted && !documents.riskAssesment.isRejected" style="margin-bottom: 20px; text-align: right;">
                <el-checkbox v-model="confirmation"></el-checkbox>&nbsp;
                <span style="font-size: 14px;">{{$t('project_tab_documents_commercial_clicking')}}</span>
            </div>

            <div v-if="documents.riskAssesment.level !== 0 && !documents.riskAssesment.isAccepted && !documents.riskAssesment.isRejected" class="item__btn">
                <el-button :disabled="!confirmation" type="success" size="mini" @click="accept(4)">{{$t('project_tab_documents_accept')}}</el-button>
                <el-button type="danger" size="mini" @click="reject(4)">{{$t('project_tab_documents_reject')}}</el-button>
            </div>
        </div>

        <div v-if="title === 'envirenmental' || title === 'general'" class="item">
            <div v-if="documents.envirenmental.editMessage" class="item__note">
                <el-alert
                        title="Information"
                        type="warning"
                        :description="documents.envirenmental.editMessage"
                        show-icon>
                </el-alert>
            </div>
            <div class="item__title">
                <div v-if="documents.envirenmental.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('project_tab_documents_accept')}}</el-tag>
                </div>
                <div v-if="documents.envirenmental.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('project_tab_documents_reject')}}</el-tag>
                </div>
            </div>
            <div v-html="documents.envirenmental.content" class="item__content"></div>

            <el-dropdown v-for="item in documents.envirenmental.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.name}}</span>
                  </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url + `/${item.name}`)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}/${item.name}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                </el-dropdown-menu>
            </el-dropdown>

            <!-- confirmation -->
            <div v-if="documents.envirenmental.level !== 0 && !documents.envirenmental.isAccepted && !documents.envirenmental.isRejected" style="margin-bottom: 20px; text-align: right;">
                <el-checkbox v-model="confirmation"></el-checkbox>&nbsp;
                <span style="font-size: 14px;">{{$t('project_tab_documents_general_clicking')}}</span>
            </div>

            <div v-if="documents.envirenmental.level !== 0 && !documents.envirenmental.isAccepted && !documents.envirenmental.isRejected" class="item__btn">
                <el-button :disabled="!confirmation" type="success" size="mini" @click="accept(5)">{{$t('project_tab_documents_accept')}}</el-button>
                <el-button type="danger" size="mini" @click="reject(5)">{{$t('project_tab_documents_reject')}}</el-button>
            </div>
        </div>

        <!--VIEWER-->
        <div v-if="viewerType == 1">
            <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
                <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
            </sweet-modal>
        </div>
        <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
                <img :src="fileUrl" :key="fileUrl" />
            </div>
        </div>
        <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'video'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
        <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'audio'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>

    </el-dialog>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import Media from '@dongido/vue-viaudio'
  import fileImg from '../../fileImg'
  import axios from 'axios'
  export default {
    name: "LaterDocumentModal",
    components: {
      SweetModal,
      fileImg,
      Media
    },
    computed: {

    },
    data(){
      return {
        title: 'Notification',
        dialog: false,
        documents: {
          sop:{

          },
          policy: {

          },
          healthsafety:{

          },
          riskAssesment: {

          },
          envirenmental: {

          }
        },
        document: {},
        confirmation: false,
        // reject
        documentId: null,
        typeDocument: null,
        viewerType: 0,
        fileUrl: '',
        type: ''
      }
    },
    methods:{
      async openModal(document){
        try {
          this.document = document;

          switch (document.type) {
            case 'envirenmental' :
              this.title = 'general';
              break;
            case 'riskassesment' :
              this.title = 'commercial';
              break;
            default:
              this.title = document.type;
          }

          this.documents = await this.getDocuments(document);


          this.dialog = true

        } catch (err) {
          console.log(err)
        }
      },
      getDocuments(document){
        return new Promise ((resolve, reject) => {
          let url = '';
          switch (document.taskType) {
            case 'PROJECT':
              url = `/api/v1/projectTasks/documents/list?companyId=${this.$route.query.companyId}&projectId=${document.projectId}&projectTaskId=${document.projectTaskId || document.taskId}`;
              break;
            case 'BUSINESSUNIT':
              url = `/api/v1/businessUnitTasks/documents/list?companyId=${this.$route.query.companyId}&businessUnitId=${document.businessUnitId || document.projectId}&businessUnitTaskId=${document.businessUnitTaskId || document.taskId}`;
              break;
            case'ENGAGEMENT':
              url = `/api/v1/engagementTasks/documents/list?companyId=${this.$route.query.companyId}&engagementId=${document.engagementId || document.projectId}&engagementTaskId=${document.engagementTaskId || document.taskId}`;
              break;
          }

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(url)
            .then(response => {
              console.log('/engagementTasks/documents', response.data);
              resolve(response.data);
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error);
              loader.hide()
            });
        })
      },
      accept(type) {
        let typeDocument = '';
        switch (type) {
          case 1:
            typeDocument = 'sop';
            this.documentId = this.documents.sop.id;
            break;
          case 2:
            typeDocument = 'policy';
            this.documentId = this.documents.policy.id;
            break;
          case 3:
            typeDocument = 'healthsafety';
            this.documentId = this.documents.healthsafety.id;
            break;
          case 4:
            typeDocument = 'riskAssesment';
            this.documentId = this.documents.riskAssesment.id;
            break;
          case 5:
            typeDocument = 'envirenmental';
            this.documentId = this.documents.envirenmental.id;
            break;
        }

        let url = '';
        switch (this.document.taskType) {
          case 'PROJECT':
            url = `/api/v1/projectTasks/acceptDocument?companyId=${this.$route.query.companyId}&projectId=${this.document.projectId}&projectTaskId=${this.document.projectTaskId || this.document.taskId}&type=${typeDocument}&documentId=${this.documentId}`;
            break;
          case 'BUSINESSUNIT':
            url = `/api/v1/businessUnitTasks/acceptDocument?companyId=${this.$route.query.companyId}&businessUnitId=${this.document.businessUnitId || this.document.projectId}&businessUnitTaskId=${this.document.businessUnitTaskId || this.document.taskId}&type=${typeDocument}&documentId=${this.documentId}`;
            break;
          case'ENGAGEMENT':
            url = `/api/v1/engagementTasks/acceptDocument?companyId=${this.$route.query.companyId}&engagementId=${this.document.engagementId || this.document.projectId}&engagementTaskId=${this.document.engagementTaskId || this.document.taskId}&type=${typeDocument}&documentId=${this.documentId}`;
            break;
        }


        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(url)
          .then(async response => {
            try {
              this.documents = await this.getDocuments(this.document);

              // switch (this.document.taskType) {
              //   case 'PROJECT':
              //     this.$store.commit('getDocuments', this.documents);
              //     break;
              //   case 'BUSINESSUNIT':
              //     this.$store.commit('getDocumentsBU', this.documents);
              //     break;
              //   case'ENGAGEMENT':
              //     this.$store.commit('getDocumentsE', this.documents);
              //     break;
              // }

              this.$message({
                type: 'success',
                message: 'Accept'
              });
              loader.hide();
              this.confirmation = false;
              this.dialog = false;

            } catch (err){
              console.log(err)
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      reject(type) {
        switch (type) {
          case 1:
            this.typeDocument = 'sop';
            this.documentId = this.documents.sop.id;
            break;
          case 2:
            this.typeDocument = 'policy';
            this.documentId = this.documents.policy.id;
            break;
          case 3:
            this.typeDocument = 'healthsafety';
            this.documentId = this.documents.healthsafety.id;
            break;
          case 4:
            this.typeDocument = 'riskAssesment';
            this.documentId = this.documents.riskAssesment.id;
            break;
          case 5:
            this.typeDocument = 'envirenmental';
            this.documentId = this.documents.envirenmental.id;
            break;
        }

        this.$prompt(this.$t('project_tab_documents_reject_text'), this.$t('project_tab_documents_reject_title'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
        }).then(({ value }) => {
          this.rejectModal(value)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Input canceled'
          });
        });

        // this.innerVisible = true
      },
      rejectModal(msg) {

        let url = '';
        switch (this.document.taskType) {
          case 'PROJECT':
            url = `/api/v1/projectTasks/rejectDocument?companyId=${this.$route.query.companyId}&projectId=${this.document.projectId}&projectTaskId=${this.document.projectTaskId || this.document.taskId}&type=${this.typeDocument}&documentId=${this.documentId}`;
            break;
          case 'BUSINESSUNIT':
            url = `/api/v1/businessUnitTasks/rejectDocument?companyId=${this.$route.query.companyId}&businessUnitId=${this.document.businessUnitId || this.document.projectId}&businessUnitTaskId=${this.document.businessUnitTaskId || this.document.taskId}&type=${this.typeDocument}&documentId=${this.documentId}`;
            break;
          case'ENGAGEMENT':
            url = `/api/v1/engagementTasks/rejectDocument?companyId=${this.$route.query.companyId}&engagementId=${this.document.engagementId || this.document.projectId}&engagementTaskId=${this.document.engagementTaskId || this.document.taskId}&type=${this.typeDocument}&documentId=${this.documentId}`;
            break;
        }
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(url, {
          rejectMessage: msg
        })
          .then(async response => {
            try {
              this.documents = await this.getDocuments(this.document);

              // switch (this.document.taskType) {
              //   case 'PROJECT':
              //     this.$store.commit('getDocuments', this.documents);
              //     break;
              //   case 'BUSINESSUNIT':
              //     this.$store.commit('getDocumentsBU', this.documents);
              //     break;
              //   case'ENGAGEMENT':
              //     this.$store.commit('getDocumentsE', this.documents);
              //     break;
              // }
              this.confirmation = false;
              this.dialog = false;

              this.$message({
                type: 'success',
                message: 'Message sent'
              });
              loader.hide()
            } catch (err){
              console.log(err)
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      handleClose(){
        this.title = 'Warning';
        this.dialog = false;
        this.documents = {};
        this.document = {};
        this.confirmation = false;
        this.documentId = null;
        this.typeDocument = null;
        this.viewerType = 0;
        this.fileUrl = '';
        this.type = '';
      },
      viewFile(url) {
        let type = url.split('.').pop().toUpperCase()
        if (type == 'GIF' || type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF' || type === 'XLS' || type === 'DOCX' || type === 'DOC' || type === 'XLSX') {
          this.fileUrl = url
          this.type = this.fileUrl.split('.').pop().toUpperCase()
          console.log('---', this.fileUrl, this.type);

          if (this.type == 'GIF' || this.type == 'JPG' || this.type == 'JPEG' || this.type == 'PNG' || this.type == 'BMP') {
            this.viewerType = 2;
            setTimeout(() => {
              console.log('-----', this.$el);
              const viewer = this.$el.querySelector('.images').$viewer
              viewer.show()
            }, 300);
          } else if (this.type == 'OGG' || this.type == 'MP4') {
            this.viewerType = 3;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (this.type == 'WMA' || this.type == 'MP3' || this.type == 'WAV' || this.type == 'OGG' || this.type == 'M4A') {
            this.viewerType = 4;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (this.type == 'PDF') {
            this.viewerType = 1;
            this.fileUrl = process.env.VUE_APP_TF_PDF_VIEWER_BASE_URL + '/?file=' + this.fileUrl;
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          } else if (this.type == 'STEP' || this.type == 'STP' || this.type == 'IGES' || this.type == 'IGS' || this.type == 'BREP' || this.type == 'STL' || this.type == 'SAT' || this.type == 'X_T' || this.type == 'X_B' || this.type == 'SLDPRT' || this.type == 'DWG' || this.type == 'DXF' || this.type == 'DWF' || this.type == 'HPGL' || this.type == 'PLT' || this.type == 'CGM' || this.type == 'SVG' || this.type == 'EMF' || this.type == 'WMF') {
            // this.viewerType = 1;
            this.fileUrl = 'https://sharecad.org/cadframe/load?url=' + this.fileUrl;
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          }else if (this.type === 'XLS' || this.type === 'DOCX' || this.type === 'DOC' || this.type === 'XLSX'){
            const win = window.open(`https://view.officeapps.live.com/op/view.aspx?src=${this.fileUrl}`, '_blank');
            win.focus();
          }
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
    /deep/.el-dialog__body {
        padding-top:0 !important;
    }
    .el-divider--horizontal {
        margin: 8px 0 !important;
    }
    .box-card_title {
        color: #888;
        font-size: 16px;
    }
    .item {
        &__note {
            margin-bottom: 10px;
        }
        &__title {
            position: relative;
            font-size: 20px;
            color: #909399;
        }
        &__status {
            position: absolute;
            top: 10px;
            right: 10px;
        }
        &__content {
            margin-bottom: 10px;
        }
        &__file {
            margin-bottom: 10px;
            display: flex;
            justify-content: flex-end;
        }
        &__btn {
            display: flex;
            justify-content: flex-end;
        }
    }
    /deep/.download-btn{
        a{
            color:#606266;
            &:hover{
                color:#66b1ff;
            }
        }
    }
</style>
